import { Component, Input, OnInit } from '@angular/core';
import { FeiraModel } from '../../../events/model/event.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DocumentoService } from '../../services/documento.service';
import { Documento } from '../../models/documento.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Projeto } from '../../../projects/models/project.model';
import { ToastService } from 'src/app/shared/toasts/toast-service';

// Resposável pela modal que adiciona um novo documento.
@Component({
  selector: 'app-add-documents-modal',
  templateUrl: './add-documents-modal.component.html',
  styleUrl: './add-documents-modal.component.scss'
})
export class AddDocumentsModalComponent implements OnInit {
  @Input() projetoId: string = '';

  documentoForm!: FormGroup;

  constructor(
    private toastService: ToastService,
    public activeModal: NgbActiveModal,
    private documentoService: DocumentoService,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.documentoForm = this.fb.group({
      projetoId: [this.projetoId],
      descricao: ["", Validators.required],
      tipoDocumento: [, Validators.required]
    });
  }

  adicionarProduto(): void {
    if (!this.documentoForm.valid) {
      this.documentoForm.markAllAsTouched();
      return;
    }

    const documentoValies = this.documentoForm.value;

    
    const novoDocumento: Documento = {
      nomeFeira: '',
      descricao: documentoValies.descricao,
      projetoId: this.projetoId,
      tipoDocumento: parseInt(documentoValies.tipoDocumento)
    }
    
    this.documentoService.adicionarDocumento(novoDocumento);

    this.activeModal.dismiss();

    this.toastService.show("Cadastro com sucesso!", {
      classname: "bg-success text-light",
    });

    //this.documentoForm.reset();
  }
}
